import URLParam from "./URLParam";
import EntryLink from "./EntryLink";

export default class ExampleLinkBuilder {

    private config: EntryLink;

    /**
     * Provide URL config
     *
     * @param config
     */
    constructor(config: EntryLink) {
        this.config = config;
    }

    /**
     * Build and return link
     */
    protected get()
    {
        if (this.config.base_url) {
            let link = this.config.base_url;

            if (!link.includes('?')) {
                link += '?';
            } else {
                link += '&';
            }

            link += this.config.pid_param + '=[value]';

            this.config.params.forEach((param: URLParam) => {

                link += '&' + param.name + '=[value]';
            });

            if (this.config.hash_algo !== 'None') {
                link += '&' + this.config.hash_param + '=[value]';
            }

            return link;
        }
    }
}